module.exports = __webpack_public_path__ + "static/media/s_purple_1.8e0df24a.mp3";